import { render } from "./ProposalSendModal.vue?vue&type=template&id=f2f31448&scoped=true"
import script from "./ProposalSendModal.vue?vue&type=script&lang=js"
export * from "./ProposalSendModal.vue?vue&type=script&lang=js"

import "./ProposalSendModal.vue?vue&type=style&index=0&id=f2f31448&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2f31448"]])

export default __exports__